/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import React from 'react';
import PropTypes from 'prop-types';
import isEmpty from 'lodash/isEmpty';
import { Select } from 'sarsaparilla';
import { gnoment } from 'shared-ui/gnoment';

export default function DateSelector({
    isTextOnly = false,
    isLabelVisible = true,
    dates = [],
    value,
    onChange,
    permitClosed = false,
    displayAvailabilityRange = false,
    availability,
}) {
    if (isEmpty(dates)) {
        return (
            <div id="dates-empty">
                {permitClosed ? (
                    <b>This permit is not available this season.</b>
                ) : (
                    <b>
                        This permit registration is currently closed for the season. Check
                        back for when this will release.
                    </b>
                )}
            </div>
        );
    }
    if (isTextOnly) {
        return (
            <div id="dates">
                {isLabelVisible && <label htmlFor="dates">Dates</label>}
                {dates.map((d) => (
                    <div key={d}>
                        {/\//.test(d)
                            ? d
                                  .split('/')
                                  .map((f) => gnoment(f).format('ll'))
                                  .join(' - ')
                            : gnoment(d).format('ddd, ll')}
                    </div>
                ))}
            </div>
        );
    }
    let options = dates.map((d) => ({
        value: d,
        label: gnoment(d).format('LL'),
    }));

    if (displayAvailabilityRange) {
        options = availability?.map((item) => {
            return {
                value: item.start_date,
                label: `${gnoment(item?.start_date).format('LL')} - ${gnoment(item?.permit_type_end).format('LL')}`,
            };
        });
    }

    return (
        <Select
            isRequired
            isLabelVisible={isLabelVisible}
            label="Date"
            id="date"
            placeholder="Select date"
            options={options}
            onChange={({ target: { value: v } }) => onChange(v)}
            value={value}
        />
    );
}

DateSelector.propTypes = {
    isTextOnly: PropTypes.bool,
    isLabelVisible: PropTypes.bool,
    dates: PropTypes.array,
    value: PropTypes.string,
    onChange: PropTypes.func,
    displayAvailabilityRange: PropTypes.bool,
    availability: PropTypes.array,
    permitClosed: PropTypes.bool,
};
